import { setInterval, clearInterval } from '@/utils/safe.timers';
import { PrinterWorker } from './printer.worker';
import { tokenWorker } from './token.worker';
import { CleanWorker } from './clean.worker';
import { networkWorker } from './network.worker';

export class WorkManager {
  private static instance: WorkManager;
  private printerWorkerService: WorkService;
  private tokenWorkerService: WorkService;
  private cleanWorkerService: WorkService;
  private networkWorkerService: WorkService;
  private updateWorkerService: WorkService;
  private kdsBadgeWorkerService: WorkService;
  private autoShiftWorkerService: WorkService;
  private cdsWorkerService: WorkService;

  private constructor() {
    this.printerWorkerService = new WorkService();
    this.tokenWorkerService = new WorkService();
    this.cleanWorkerService = new WorkService();
    this.networkWorkerService = new WorkService();
    this.updateWorkerService = new WorkService();
    this.kdsBadgeWorkerService = new WorkService();
    this.autoShiftWorkerService = new WorkService();
    this.cdsWorkerService = new WorkService();
  }

  public static getInstance(): WorkManager {
    if (!WorkManager.instance) {
      WorkManager.instance = new WorkManager();
    }
    return WorkManager.instance;
  }

  startPrinterWorker(interval: number): void {
    this.printerWorkerService.startWork(PrinterWorker, interval);
  }

  stopPrinterWorker(): void {
    this.printerWorkerService.stopWork();
  }

  startTokenWorker(interval: number): void {
    this.tokenWorkerService.startWork(tokenWorker, interval);
  }

  stopTokenWorker(): void {
    this.tokenWorkerService.stopWork();
  }

  startCleanWorker(interval: number): void {
    this.cleanWorkerService.startWork(CleanWorker, interval);
  }

  stopCleanWorker(): void {
    this.cleanWorkerService.stopWork();
  }

  startNetworkWorker(interval: number): void {
    this.networkWorkerService.startWork(networkWorker, interval);
  }

  stopNetworkWorker(): void {
    this.networkWorkerService.stopWork();
  }

  startUpdateWorker(callback: () => void, interval: number): void {
    this.updateWorkerService.startWork(callback, interval);
  }

  stopUpdateWorker(): void {
    this.updateWorkerService.stopWork();
  }

  startKdsBadgeWorker(callback: () => void, interval: number): void {
    this.kdsBadgeWorkerService.startWork(callback, interval);
  }

  stopKdsBadgeWorker(): void {
    this.kdsBadgeWorkerService.stopWork();
  }

  startAutoShiftWorker(callback: () => void, interval: number): void {
    this.autoShiftWorkerService.startWork(callback, interval);
  }

  stopAutoShiftWorker(): void {
    this.autoShiftWorkerService.stopWork();
  }

  startCdsWorker(callback: () => void, interval: number): void {
    this.cdsWorkerService.startWork(callback, interval);
  }

  stopCdsWorker(): void {
    this.cdsWorkerService.stopWork();
  }
}

class WorkService {
  private intervalId: number | null = null;
  private currentCallback: (() => void) | null = null;

  startWork(callback: () => void, interval: number): void {
    if (this.currentCallback === callback) return;
    this.stopWork();
    this.intervalId = setInterval(callback, interval);
    this.currentCallback = callback;
  }

  stopWork(): void {
    if (!this.intervalId) return;
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.currentCallback = null;
  }
}
